import React, { useState } from "react";
import * as Yup from "yup";
import { Row, Col } from "@/components/Grid";
import { Button } from "@/components/Common";
import { Form, Input, InputMask } from "@/components/Form";
import toastify from "@/services/toastify";
import api from "@/services/api";
import { ModalContent, ModalFooter } from "./styles";

export default function ModalAceiteResponsavel({ tceId, onClose, codigo }) {
  const schema = Yup.object().shape({
    nome: Yup.string().required("Obrigatório"),
    cpf: Yup.string().required("Obrigatório"),
  });

  const [Nome, setNome] = useState("");
  const [Cpf, setCpf] = useState("");
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState(null);

  async function handleSubmit() {
    setErro(null);
    setLoading(true);
    try {
      const endpoint = `responsavel-tce/${tceId}/${codigo}`;
      const { data: response } = await api.put(endpoint, {
        nome: Nome,
        cpf: Cpf,
      });
      if (response.success) {
        toastify("Contrato aceito com sucesso");
        window.location.reload(true);
      } else {
        setErro(response.message || "Erro ao aceitar o contrato. Verifique os dados e tente novamente.");
      }
    } catch (e) {
      const msg = e?.response?.data?.message;
      setErro(msg || "Erro ao aceitar o contrato. Verifique os dados e tente novamente.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <ModalContent>
      <h2>Dados do assinante</h2>
      <Form schema={schema} onSubmit={handleSubmit}>
        <Row>
          <Col>
            <Input
              id="nome"
              name="nome"
              label="Nome:"
              onChange={e => setNome(e.target.value)}
            />
          </Col>
        </Row>
        <Row hascols>
          <Col>
            <InputMask
              id="cpf"
              name="cpf"
              type="cpf"
              label="CPF:"
              onChange={e => setCpf(e.target.value)}
            />
          </Col>
        </Row>
        {erro && (
          <p style={{ color: "#c0392b", fontSize: "13px", margin: "8px 0 0" }}>
            {erro}
          </p>
        )}
        <ModalFooter>
          <Button onClick={() => handleSubmit()} block variant="tangerine" loading={loading || undefined}>
            Aceitar
          </Button>
          <Button
            type="button"
            block
            variant="cancel"
            onClick={() => onClose()}
          >
            Cancelar
          </Button>
        </ModalFooter>
      </Form>
    </ModalContent>
  );
}
